module.exports = __webpack_public_path__ + "static/media/icon_edit.6e56e54d.svg";